export const isAuthenticated = () => {
  let localStorageValues = localStorage.getItem('loginUserDetails')
  let parseUserData = JSON.parse(localStorageValues);
  if (parseUserData != null && parseUserData.isLogin) 
    return true;
  else
    return false;
};
